import React from "react";

/** Премиальный переключатель ANGIOLINI: золото в активном состоянии. */
export const GoldSwitch = ({ on, onClick, disabled = false, testId, label }) => (
  <button data-testid={testId} onClick={onClick} role="switch" aria-checked={on} aria-label={label}
    disabled={disabled}
    style={{ flexShrink: 0, width: "46px", height: "26px", borderRadius: "13px", position: "relative",
      border: `1px solid ${on ? "var(--ang-gold-line)" : "var(--ang-border-strong)"}`,
      background: on ? "linear-gradient(135deg,var(--ang-gold),var(--ang-gold-2))" : "var(--ang-surface-2)",
      cursor: disabled ? "default" : "pointer", opacity: disabled ? 0.45 : 1, padding: 0,
      transition: "background .25s ease, border-color .25s ease" }}>
    <span style={{ position: "absolute", top: "2px", left: on ? "22px" : "2px",
      width: "20px", height: "20px", borderRadius: "50%",
      background: on ? "#FBF2E2" : "var(--ang-text-faint)",
      boxShadow: "0 1px 3px rgba(0,0,0,0.25)",
      transition: "left .25s cubic-bezier(.4,0,.2,1), background .25s ease" }} />
  </button>
);

export default GoldSwitch;
